"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarModeEnum = void 0;
var CalendarModeEnum;
(function (CalendarModeEnum) {
    CalendarModeEnum["YEAR"] = "Year";
    CalendarModeEnum["MONTH"] = "Month";
    CalendarModeEnum["WEEK"] = "Week";
    CalendarModeEnum["DAY"] = "Day";
})(CalendarModeEnum = exports.CalendarModeEnum || (exports.CalendarModeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FsZW5kYXItbW9kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jYWxlbmRhci9jYWxlbmRhci1tb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksZ0JBS1g7QUFMRCxXQUFZLGdCQUFnQjtJQUMxQixpQ0FBYSxDQUFBO0lBQ2IsbUNBQWUsQ0FBQTtJQUNmLGlDQUFhLENBQUE7SUFDYiwrQkFBVyxDQUFBO0FBQ2IsQ0FBQyxFQUxXLGdCQUFnQixHQUFoQix3QkFBZ0IsS0FBaEIsd0JBQWdCLFFBSzNCIn0=